/**
 * ОДНО СЛОВО ОТКАЗА НА ВСЮ ПАНЕЛЬ (`s406`, В-14 реестра `aud3`).
 *
 * ⛔ ИХ БЫЛО ТРИ, И НАПИСАЛИ ИХ ТРИ РАЗНЫЕ СЕССИИ:
 *   «Этот раздел вам **не открыт**»            — гейт права (`RequirePermission`);
 *   «Этот раздел вам **не показывают**»        — гейт видимости (`RequireVidimost`);
 *   «У вас **нет доступа** к клиенткам»        — экран данных (`ScreenState`).
 * Человек, упёршийся в стену, читал три разные формулировки одного и того же и
 * искал между ними разницу, которой для него нет.
 *
 * ⛔ РАЗНИЦА МЕЖДУ НИМИ СУЩЕСТВУЕТ — И ОНА НЕ ЕГО ДЕЛО. «Нет права» и «право
 * есть, но раздел спрятан настройкой» — разные вещи для того, кто РАЗДАЁТ
 * доступ, и одна и та же для того, кто в неё упёрся: идти всё равно к владельцу.
 * Прежний текст видимости прямо сообщал «права у вас при этом не отбирали» —
 * то есть рассказывал постороннему, как устроена настройка чужого доступа.
 * Различие не потеряно: оно уходит в след, где его читает тот, кому оно нужно.
 *
 * ⛔ ЛИТЕРАЛ, А НЕ СЛОВАРЬ, И ПРИЧИНА ФИЗИЧЕСКАЯ. Словарь экрана приезжает
 * ВМЕСТЕ с ответом экрана, а при отказе ответа нет вовсе — `words` остаётся
 * пустым, и строка из `ui_terms` до этого места не доезжает НИКОГДА. Именно так
 * слово `view.no_right`, честно посаженное в базу `s206`, ни разу и не
 * показалось: правку текста в базе тут просто некому доставить. Поэтому
 * источник один — вот этот файл, а серверная половина держит ту же фразу в
 * `otkaz.dostup/razdel`, и ловушка сверяет их между собой.
 */

export const OTKAZ_ZAGOLOVOK = 'Этот раздел вам не открыт';

export const OTKAZ_PODPIS = 'Если он нужен для работы, попросите владельца открыть доступ.';

/** Одной строкой — там, где заголовка и подписи порознь нет (экраны данных). */
export const OTKAZ_STROKOY = `${OTKAZ_ZAGOLOVOK}. ${OTKAZ_PODPIS}`;
